export const InstrumentDataStatus = {
  PENDING_INITIAL_DOWNLOAD: "PENDING_INITIAL_DOWNLOAD",
  AVAILABLE: "AVAILABLE",
  UPDATING: "UPDATING",
  ERROR: "ERROR",
};


export const AnalysisJobStatus = {
  PENDING: "PENDING",
  FETCHING_DATA: "FETCHING_DATA",
  RESAMPLING_DATA: "RESAMPLING_DATA",
  CALCULATING_INDICATORS: "CALCULATING_INDICATORS",
  RUNNING_ANALYSIS: "RUNNING_ANALYSIS",
  COMPLETED_SUCCESS: "COMPLETED_SUCCESS",
  COMPLETED_FAIL: "COMPLETED_FAIL",
};


export const InstrumentDataStatusDisplay = {
  [InstrumentDataStatus.PENDING_INITIAL_DOWNLOAD]: "Pending Initial Download",
  [InstrumentDataStatus.AVAILABLE]: "Available",
  [InstrumentDataStatus.UPDATING]: "Updating",
  [InstrumentDataStatus.ERROR]: "Error",
};

export const AnalysisJobStatusDisplay = {
  [AnalysisJobStatus.PENDING]: "Pending",
  [AnalysisJobStatus.FETCHING_DATA]: "Fetching Data",
  [AnalysisJobStatus.RESAMPLING_DATA]: "Resampling Data",
  [AnalysisJobStatus.CALCULATING_INDICATORS]: "Calculating Indicators",
  [AnalysisJobStatus.RUNNING_ANALYSIS]: "Running Analysis",
  [AnalysisJobStatus.COMPLETED_SUCCESS]: "Completed Successfully",
  [AnalysisJobStatus.COMPLETED_FAIL]: "Failed",
};
